import { SpecialTour } from 'shared/api/tours/search'
import { addDate, dateFormat } from 'shared/lib/dateFormat.ts'

export const getTourDate = (tour?: SpecialTour) => {
  const checkin = tour?.checkin_date
  const checkout = addDate({
    date: checkin,
    count: tour?.nights || 0,
    type: 'day',
  })

  return `${dateFormat(checkin)} - ${dateFormat(checkout)}`
}
